import React from 'react'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import List from '@mui/material/List'
import { SidebarMenuItem } from './MenuItem'
import { ISidebarMenuItem } from 'app/menu/components/Sidebar/Menu'

const useStyles = makeStyles(() =>
  createStyles({
    sidebarMenu: {
      width: '100%'
    }
  })
)

export interface sidebarMenuListProps {
  menuItems: ISidebarMenuItem[]
  open: boolean
  ID: number
  popoverID: string | null
  anchorEl: HTMLElement | null
  handleClickAnchor: (event: React.MouseEvent<EventTarget>, ID: string) => void
  handleCloseAnchor: (url: string | undefined) => void
}

export const SidebarMenuList: React.FC<sidebarMenuListProps> = props => {
  const classes = useStyles()
  const { menuItems, open, ID, popoverID, anchorEl, handleClickAnchor, handleCloseAnchor } = props

  return (
    <List component='nav' className={classes.sidebarMenu} disablePadding>
      {menuItems.map((item, index) => (
        <SidebarMenuItem
          {...item}
          key={index}
          drawerOpen={open}
          ID={`${ID}-${index}`}
          anchorEl={anchorEl}
          popoverID={popoverID}
          handleClickAnchor={handleClickAnchor}
          handleCloseAnchor={handleCloseAnchor}
        />
      ))}
    </List>
  )
}
